import { Colors } from "@/enums/Colors";
import { FormControl, FormControlProps, MenuItem, Select, SxProps, Theme } from "@mui/material";

interface SelectInputProps {
  options: any;
  onChange: (value: any) => void;
  value: any;
  disabled?: boolean;
  FormControlProps?: Omit<FormControlProps, "error">;
  id?: string;
  error?: boolean;
  onBoardingForm?: boolean;
}

export const LazoSelectInput = ({
  options,
  onChange,
  value,
  disabled,
  FormControlProps,
  error,
  id,
  onBoardingForm = false,
}: SelectInputProps) => {
  return (
    <FormControl sx={{ width: "100%" }}>
      <Select
        value={value}
        id={id}
        disabled={disabled}
        onChange={onChange}
        error={error}
        sx={selectStyles}
        MenuProps={
          onBoardingForm
            ? {
                PaperProps: {
                  sx: {
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    border: "solid 1px rgba(0, 0, 0, 0.1)",
                    maxHeight: "300px",
                    overflow: "auto",
                  },
                },
              }
            : {}
        }
      >
        {options.map((option, index) => (
          <MenuItem key={index} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
export default LazoSelectInput;

const selectStyles: SxProps<Theme> = {
  "& .MuiOutlinedInput-notchedOutline": {
    border: `1px solid ${Colors.STONE_GRAY}`,
  },
  borderRadius: ".75rem",
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: `1px solid ${Colors.AMATIST_PURPLE}`,
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: `1px solid ${Colors.AMATIST_PURPLE}`,
  },
};
